"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModel = void 0;
const mobx_1 = require("mobx");
const ide_lib_reactor_utils_1 = require("@journeyapps-platform/ide-lib-reactor-utils");
let BaseModel = (() => {
    var _a, _BaseModel_options_accessor_storage;
    let _classSuper = ide_lib_reactor_utils_1.BaseObserver;
    let _options_decorators;
    let _options_initializers = [];
    let _options_extraInitializers = [];
    return _a = class BaseModel extends _classSuper {
            get options() { return __classPrivateFieldGet(this, _BaseModel_options_accessor_storage, "f"); }
            set options(value) { __classPrivateFieldSet(this, _BaseModel_options_accessor_storage, value, "f"); }
            constructor(options) {
                super();
                _BaseModel_options_accessor_storage.set(this, __runInitializers(this, _options_initializers, void 0));
                __runInitializers(this, _options_extraInitializers);
                this.options = options;
            }
            delete() {
                this.iterateListeners((cb) => { var _b; return (_b = cb.deleted) === null || _b === void 0 ? void 0 : _b.call(cb); });
            }
            get clients() {
                return this.options.clients;
            }
            async getParents() {
                return [];
            }
            async getParentResourceSelectors() {
                const parents = await this.getParents();
                let transformed = [];
                for (let parent of parents) {
                    const res = await parent.getResourceSelector();
                    if (res) {
                        transformed.push(res);
                    }
                }
                return transformed;
            }
            async getResourceSelector() {
                return null;
            }
            async getComparativeResource() {
                return null;
            }
        },
        _BaseModel_options_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _options_decorators = [mobx_1.observable];
            __esDecorate(_a, null, _options_decorators, { kind: "accessor", name: "options", static: false, private: false, access: { has: obj => "options" in obj, get: obj => obj.options, set: (obj, value) => { obj.options = value; } }, metadata: _metadata }, _options_initializers, _options_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
exports.BaseModel = BaseModel;
